import React from 'react'

/**
 * Get a string date and converts to
 * human-readable date type
 * Ex.: DD/MM/YYYY at hh:mm:ss
 * @param {string} date
 */
export function dateFormat(date) {
  if ( !date ) return <span style={{color: "#c1c1c1"}}>Sem data definida.</span>

  if ( isNaN(Date.parse(date)) ) {
    console.error("Error: Invalid date string provided. Returning null. \r\n    in dateFormat (at src/_helpers/DateFormat/index.js:7)")
    return null
  }

  let dt = date.split('T')
  let d = dt[0].split('-')
  let h = dt[1].split('.')[0]

return <p style={{margin: 0, lineHeight: "14px"}}>{`${d[2]}/${d[1]}/${d[0]}`}<br/><span style={{color: "#aaa", fontSize: "12px"}}>{h}</span></p> 
}